/* eslint-disable react/jsx-no-bind */
import { useBuild } from "app/components/build/Show/lib/BuildContext";
import AnnotationsListRenderer from "../components/AnnotationsListRenderer";
import { useReactRouterNavigateHandler } from "../lib/useReactRouterNavigateHandler";

const Annotations = () => {
  const { build } = useBuild();
  const navigateClickHandler = useReactRouterNavigateHandler();

  return (
    <div onClick={navigateClickHandler}>
      <AnnotationsListRenderer
        params={{
          buildSlug: `${build.account.slug}/${build.project.slug}/${build.number}`,
        }}
        organization={build.account.slug}
        pipeline={build.project.slug}
        number={build.number}
        filterIssues={false}
        hasFailedJobs={false}
      />
    </div>
  );
};

export default function AnnotationsPage() {
  return (
    <div className="relative min-w-0 flex-auto">
      <div className="absolute flex h-full w-full overflow-y-auto">
        <div className="relative flex w-full flex-col gap-2 p-3">
          <Annotations />
        </div>
      </div>
    </div>
  );
}
